export const fullCentreTitle = centre =>
  `Westfield ${centre.title} Shopping Centre`
